module.exports = __webpack_public_path__ + "static/img/TH.fcefcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/TH.png
// module id = xg+e
// module chunks = 1